import { Box, Button, Modal, TextField, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import { useState } from "react";
import { getFunctions, httpsCallable } from "firebase/functions";

interface Props {
  open: boolean;
  handleClose: () => void;
  text?: string;
}

const ApplyNowForm: React.FC<Props> = ({ open, handleClose, text }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    files: [] as File[],
  });

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFormData({ ...formData, files: Array.from(e.target.files) });
    }
  };

  // const handleSubmit = (e: React.FormEvent) => {
  //   e.preventDefault();
  //   console.log(formData);
  //   handleClose();
  // };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      const functions = getFunctions();
      const helloWorld = httpsCallable(functions, "helloWorld");
      const result = await helloWorld();
      console.log(result); // Debería decir "Hello from Firebase!"
    } catch (error) {
      console.error("Error calling Firebase function:", error);
    }

    handleClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          maxWidth: 500,
          bgcolor: "background.paper",
          color: "text.primary",
          mx: "auto",
          mt: 10,
          p: 4,
          borderRadius: 2,
        }}
      >
        <Typography variant="h5" gutterBottom>
          {text}
        </Typography>
        <Stack spacing={2}>
          <TextField
            label="Full Name"
            fullWidth
            required
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          />
          <TextField
            label="Email"
            fullWidth
            required
            type="email"
            value={formData.email}
            onChange={(e) =>
              setFormData({ ...formData, email: e.target.value })
            }
          />
          <Button variant="outlined" component="label">
            Attach CV / Cover Letter
            <input
              type="file"
              multiple
              hidden
              onChange={handleFileChange}
              accept=".pdf,.doc,.docx"
            />
          </Button>

          <Button
            type="submit"
            variant="contained"
            color="primary"
            onChange={handleSubmit}
          >
            Submit Application
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default ApplyNowForm;
